var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertasTempranasIcono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.76 110.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.08,103.23v-3.72c6.4,0,11.61-5.21,11.61-11.61V22.2c0-6.4-5.21-11.61-11.61-11.61v-3.72c8.45,0,15.33,6.88,15.33,15.33v65.7c0,8.45-6.88,15.33-15.33,15.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.68,103.23c-8.45,0-15.33-6.88-15.33-15.33V22.2c0-8.45,6.88-15.33,15.33-15.33v3.72c-6.4,0-11.61,5.21-11.61,11.61v65.7c0,6.4,5.21,11.61,11.61,11.61v3.72Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22,
    y: 49.25,
    width: 1.49,
    height: 33.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.75,63.18l-6.18-5.29c-.62-.53-.7-1.47-.16-2.1.53-.62,1.47-.7,2.1-.16l4.24,3.63,4.24-3.63c.62-.53,1.56-.46,2.1.16s.46,1.56-.16,2.1l-6.18,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.75,70.24l-6.18-5.29c-.62-.53-.7-1.47-.16-2.1.53-.62,1.47-.7,2.1-.16l4.24,3.63,4.24-3.63c.62-.53,1.56-.46,2.1.16s.46,1.56-.16,2.1l-6.18,5.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.27,
    y: 49.25,
    width: 1.49,
    height: 33.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.02,63.18l-6.18-5.29c-.62-.54-.7-1.47-.16-2.1.53-.62,1.47-.7,2.1-.16l4.24,3.63,4.24-3.63c.62-.53,1.56-.46,2.1.16s.46,1.56-.16,2.1l-6.18,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.02,70.24l-6.18-5.29c-.62-.54-.7-1.47-.16-2.1.53-.62,1.47-.7,2.1-.16l4.24,3.63,4.24-3.63c.62-.53,1.56-.46,2.1.16s.46,1.56-.16,2.1l-6.18,5.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "128.58 83.09 96.83 83.09 72.88 49.35 48.93 83.09 17.18 83.09 17.18 81.6 48.16 81.6 72.88 46.78 97.6 81.6 128.58 81.6 128.58 83.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.29,73.72c-.2,0-.41-.04-.6-.13-.75-.33-1.09-1.21-.76-1.96,1.36-3.08,2.05-6.35,2.05-9.73,0-13.29-10.81-24.1-24.1-24.1s-24.1,10.81-24.1,24.1c0,3.38.69,6.65,2.05,9.73.33.75,0,1.63-.76,1.96-.75.33-1.63,0-1.96-.76-1.53-3.46-2.31-7.14-2.31-10.93,0-14.93,12.15-27.08,27.08-27.08s27.08,12.15,27.08,27.08c0,3.79-.78,7.47-2.31,10.93-.25.56-.79.89-1.36.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.3,
    y: 62.34,
    width: 5.16,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.3,
    y: 86.55,
    width: 5.16,
    height: 4.76
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.96,33.09c-.52,0-1.03-.28-1.3-.77l-7.06-12.82c-.4-.72-.13-1.62.59-2.02.72-.4,1.62-.14,2.02.59l7.06,12.82c.4.72.13,1.62-.59,2.02-.23.13-.47.18-.72.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.74,48.27c-.26,0-.53-.07-.77-.22l-12.51-7.6c-.7-.43-.93-1.34-.5-2.04.43-.7,1.34-.93,2.04-.5l12.51,7.6c.7.43.93,1.34.5,2.04-.28.46-.77.72-1.27.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.31,69.64c-.81,0-1.47-.65-1.49-1.46-.01-.82.64-1.5,1.46-1.51l6.01-.11c.82-.05,1.5.64,1.51,1.46.01.82-.64,1.5-1.46,1.51l-6.01.11s-.02,0-.03,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.8,33.09c-.24,0-.49-.06-.72-.18-.72-.4-.98-1.3-.59-2.02l7.06-12.82c.4-.72,1.3-.98,2.02-.59.72.4.98,1.3.59,2.02l-7.06,12.82c-.27.49-.78.77-1.3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.03,48.27c-.5,0-.99-.25-1.27-.72-.43-.7-.2-1.62.5-2.04l12.51-7.6c.7-.43,1.62-.2,2.04.5.43.7.2,1.62-.5,2.04l-12.51,7.6c-.24.15-.51.22-.77.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.45,69.64s-.02,0-.03,0l-6.01-.11c-.82-.01-1.48-.69-1.46-1.51.01-.81.68-1.46,1.49-1.46,0,0,.02,0,.03,0l6.01.11c.82.01,1.48.69,1.46,1.51-.01.81-.68,1.46-1.49,1.46Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertasTempranasIcono);
export default __webpack_public_path__ + "static/media/alertas-tempranas-icono.83f5a4bde382f60163fa15a18295663b.svg";
export { ForwardRef as ReactComponent };